import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CrudService } from "./crud.service";
declare const grecaptcha: any;

@Injectable({ providedIn: "root" })
export class RecaptchaService {
  private siteKey = environment.recaptcha.siteKey;

  constructor(
    private crudService: CrudService,
    private httpClient: HttpClient
  ) {}

  executeAction(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === "undefined") {
        reject("reCAPTCHA not loaded");
      }

      grecaptcha.ready(() => {
        console.log("site key", this.siteKey, "action", action);
        grecaptcha.execute(this.siteKey, { action }).then((token: string) => {
          resolve(token);
        }, reject);
      });
    });
  }

  verifyToken(token: string, action: string, payload): Observable<any> {
    const headers = {
      "X-Captcha-Token": token,
      "X-Captcha-Action": action,
    };

    return this.httpClient.post("/api/userManagements/verify-token", payload, {
      headers: headers,
    });
  }
}
